(function() {
  if (window.__hgProductGalleryInit) return;
  window.__hgProductGalleryInit = true;

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.galleryInitialized === 'true') return;

    var slider = gallery.querySelector('.product-gallery__slider');
    var slides = gallery.querySelectorAll('.product-gallery__slide');
    var dotsWrap = gallery.querySelector('.product-gallery__dots');

    if (!slider || !dotsWrap || slides.length < 2) return;

    gallery.dataset.galleryInitialized = 'true';
    dotsWrap.innerHTML = '';

    slides.forEach(function(slide, index) {
      var dot = document.createElement('button');
      dot.className = 'product-gallery__dot';
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-label', 'Image ' + (index + 1));
      dot.addEventListener('click', function() {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dotsWrap.appendChild(dot);
    });

    var dots = dotsWrap.querySelectorAll('.product-gallery__dot');

    function syncDots() {
      var slideWidth = slider.offsetWidth || 1;
      var activeIndex = Math.round(slider.scrollLeft / slideWidth);

      dots.forEach(function(dot, index) {
        dot.classList.toggle('active', index === activeIndex);
      });
    }

    var scrollTimer;
    slider.addEventListener(
      'scroll',
      function() {
        clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncDots, 50);
      },
      { passive: true }
    );

    syncDots();
  }

  // Desktop hero galleries show a single large image plus a row of thumbnails.
  // Clicking a thumbnail swaps it into the main view so every image is reachable.
  function initDesktopThumbs(media) {
    if (!media || media.dataset.thumbsInitialized === 'true') return;

    var main = media.querySelector('[class*="__desktop-main"]');
    var thumbsWrap = media.querySelector('[class*="__thumbs"]');
    if (!main || !thumbsWrap) return;

    var thumbs = thumbsWrap.querySelectorAll('img');
    if (thumbs.length < 1) return;

    media.dataset.thumbsInitialized = 'true';
    thumbsWrap.removeAttribute('aria-hidden');

    thumbs.forEach(function(thumb) {
      var holder = thumb.parentElement;
      holder.setAttribute('role', 'button');
      holder.setAttribute('tabindex', '0');
      holder.setAttribute('aria-label', 'Show ' + (thumb.getAttribute('alt') || 'image'));

      function swap() {
        var mainSrc = main.getAttribute('src');
        var mainAlt = main.getAttribute('alt') || '';
        main.setAttribute('src', thumb.getAttribute('src'));
        main.setAttribute('alt', thumb.getAttribute('alt') || mainAlt);
        thumb.setAttribute('src', mainSrc);
        thumb.setAttribute('alt', mainAlt);
        holder.setAttribute('aria-label', 'Show ' + (thumb.getAttribute('alt') || 'image'));
      }

      holder.addEventListener('click', swap);
      holder.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          swap();
        }
      });
    });
  }

  function initProductGalleries(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-gallery').forEach(initGallery);
    scope.querySelectorAll('[class*="__desktop-media"]').forEach(initDesktopThumbs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function() {
        initProductGalleries(document);
      },
      { once: true }
    );
  } else {
    initProductGalleries(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initProductGalleries(event.target);
  });
})();
